import { useAnswerMode } from '@/data/hook/question/answers/useAnswerMode';
import { OrderingItemCreateDTO } from '@/models/Answer';
import { FlowColumn } from '@/models/DNDOrdenation';
import OrderingItemMedia from './OrderingItemMedia';
import OrderingItemText from './OrderingItemText';

type OrderingItemProps = {
  item: OrderingItemCreateDTO;
  index: number;
  totalItems: number;
  flow: FlowColumn;
  initialEditing?: boolean;
  onUpdateText: (text: string) => void;
  onUpdateMedia: (file: File | string, altText?: string) => void;
  onUpdateValidPositions: (validPositions: number[]) => void;
  onMarkIncorrect: () => void;
  onDelete: () => void;
};

export default function OrderingItem({
  item,
  totalItems,
  flow,
  initialEditing,
  onUpdateText,
  onUpdateMedia,
  onUpdateValidPositions,
  onMarkIncorrect,
  onDelete,
}: OrderingItemProps) {
  const {
    mode,
    isEditing,
    handleSwitchToMedia,
    handleSwitchToText,
    handleStartEdit,
    handleFinishEdit,
  } = useAnswerMode({
    mediaFile: item.mediaFile,
    mediaLink: item.mediaLink,
    initialEditing,
  });

  const compactClassName =
    flow === FlowColumn.HORIZONTAL ? 'w-auto min-w-0 px-4' : undefined;

  if (mode === 'media') {
    return (
      <OrderingItemMedia
        item={item}
        totalItems={totalItems}
        isEditing={isEditing}
        onStartEdit={handleStartEdit}
        onFinishEdit={handleFinishEdit}
        className={compactClassName}
        onUpdateMedia={onUpdateMedia}
        onUpdateValidPositions={onUpdateValidPositions}
        onSwitchToText={handleSwitchToText}
        onMarkIncorrect={onMarkIncorrect}
        onDelete={onDelete}
      />
    );
  }

  return (
    <OrderingItemText
      item={item}
      totalItems={totalItems}
      isEditing={isEditing}
      onStartEdit={handleStartEdit}
      onFinishEdit={handleFinishEdit}
      className={compactClassName}
      onUpdateText={onUpdateText}
      onUpdateValidPositions={onUpdateValidPositions}
      onSwitchToMedia={handleSwitchToMedia}
      onMarkIncorrect={onMarkIncorrect}
      onDelete={onDelete}
    />
  );
}
